import { $authHost } from ".."


export const getSupplierContactTypesAllAPI = async () => {
    const {data} = await $authHost.get(`api/supplier_contact_types/all`)
    return data
}